import { render, staticRenderFns } from "./AutoClaim.vue?vue&type=template&id=7840f131&scoped=true&"
import script from "./AutoClaim.vue?vue&type=script&lang=js&"
export * from "./AutoClaim.vue?vue&type=script&lang=js&"
import style0 from "./AutoClaim.vue?vue&type=style&index=0&id=7840f131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840f131",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7840f131')) {
      api.createRecord('7840f131', component.options)
    } else {
      api.reload('7840f131', component.options)
    }
    module.hot.accept("./AutoClaim.vue?vue&type=template&id=7840f131&scoped=true&", function () {
      api.rerender('7840f131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/AutoClaim.vue"
export default component.exports